import { OrderStatus } from "graphql/generated";

export const CHARGE_OTC_STATUS = [OrderStatus.PendingPayment];

export const CHARGE_SUBSCRIPTION_STATUS = [OrderStatus.PendingPrescription];

export const DETRACK_STATUS = [
  OrderStatus.Active,
  OrderStatus.PendingDelivery,
  OrderStatus.PendingPrescription,
  OrderStatus.PendingPrescriptionFu,
  OrderStatus.PrescriptionChange,
  OrderStatus.PendingPayment,
  OrderStatus.Paused
];

export const ABLE_DELETE_STATUS = [
  OrderStatus.PendingBooking,
  OrderStatus.PendingPrescription,
  OrderStatus.PendingPayment,
  OrderStatus.PendingDelivery,
  OrderStatus.PendingBookingFu,
  OrderStatus.PendingPrescriptionFu,
  OrderStatus.PrescriptionRejected,
  OrderStatus.Active,
  OrderStatus.Cancelled,
  OrderStatus.Cancel
];

export const ABLE_PAUSED_STATUS = [
  OrderStatus.PendingDelivery,
  OrderStatus.Active,
  OrderStatus.PendingPayment,
  OrderStatus.PendingPrescriptionFu,
  OrderStatus.PendingBookingFu
];

export const RENEW_STATUS = [OrderStatus.Active, OrderStatus.PendingPayment];

export const CANCEL_STATUS = [
  OrderStatus.PendingDelivery,
  OrderStatus.Active,
  OrderStatus.PendingPayment
];

export const NOT_EDIT_STATUS = [OrderStatus.Cancel, OrderStatus.Deleted, OrderStatus.Paused];

export enum OpsOrderScheduleType {
  NewRx = "new_rx",
  RenewingRx = "renewing_rx",
  CoachOnly = "coach_only",
  ConsultOnly = "consult_only"
}

export enum OpsOrderType {
  RxSubs = "RxSubs",
  OtcSubs = "OtcSubs",
  OtcOne = "OtcOne",
  RxOne = "RxOne"
}

export const STATUS_OPTIONS_BY_ORDER_TYPE = {
  [OpsOrderType.RxSubs]: [
    OrderStatus.Active,
    OrderStatus.OnHold,
    OrderStatus.PendingDelivery,
    OrderStatus.PendingPrescription,
    OrderStatus.PendingPayment,
    OrderStatus.PrescriptionRejected,
    OrderStatus.PrescriptionChange,
    OrderStatus.PendingBooking
  ],
  [OpsOrderType.OtcSubs]: [
    OrderStatus.Active,
    OrderStatus.OnHold,
    OrderStatus.PendingDelivery,
    OrderStatus.PendingPayment
  ],
  [OpsOrderType.RxOne]: [
    OrderStatus.Active,
    OrderStatus.OnHold,
    OrderStatus.PendingDelivery,
    OrderStatus.PendingPayment,
    OrderStatus.PendingPrescription,
    OrderStatus.PendingBooking
  ],
  [OpsOrderType.OtcOne]: [
    OrderStatus.Active,
    OrderStatus.OnHold,
    OrderStatus.PendingDelivery,
    OrderStatus.PendingPayment
  ]
};

// OR-3247
// the Order not exist in list can't be change

export const PENDING_PAYMENT_CASE = {
  FirstCharge: "FirstCharge",
  AfterRenew: "AfterRenew"
};

export enum BasicOrderType {
  Otc = "Otc",
  Rx = "Rx"
}

export const OPS_DROPDOWN_STATUS_OPTIONS_BY_ORDER_STATUS = {
  [OrderStatus.PendingBooking]: [],
  [OrderStatus.PendingPrescription]: [OrderStatus.Active],
  [OrderStatus.PendingPayment]: {
    [BasicOrderType.Otc]: [OrderStatus.Active],
    [BasicOrderType.Rx]: {
      [PENDING_PAYMENT_CASE.FirstCharge]: [OrderStatus.PendingPrescription, OrderStatus.Active],
      [PENDING_PAYMENT_CASE.AfterRenew]: [OrderStatus.Active]
    }
  },
  [OrderStatus.PrescriptionChange]: [OrderStatus.PendingPrescription],
  [OrderStatus.PendingDelivery]: [OrderStatus.Active],
  [OrderStatus.Active]: {
    [BasicOrderType.Otc]: [],
    [BasicOrderType.Rx]: [OrderStatus.PendingPrescription]
  },
  [OrderStatus.PendingBookingFu]: [OrderStatus.PendingPrescriptionFu],
  [OrderStatus.PendingPrescriptionFu]: [],
  [OrderStatus.Paused]: [],
  [OrderStatus.Cancelled]: [],
  [OrderStatus.Cancel]: [],
  [OrderStatus.Deleted]: [],
  [OrderStatus.PrescriptionRejected]: []
};

export const ENABLE_CHARGE_CONSULT_FEE_BY_ORDER_STATUS = [
  OrderStatus.PendingPayment,
  OrderStatus.PrescriptionChange
];

// end OR-3247
